export default __webpack_public_path__ + "static/media/paid.00bf32cf.svg";